import apiClient from './apiClient'

export type ContributionFrequency = 1 | 2 | 3   // Monthly | Quarterly | Yearly
export type ContributionType      = 1 | 2        // Employee | Orbit

export const FrequencyLabels: Record<ContributionFrequency, string> = {
  1: 'Měsíčně',
  2: 'Čtvrtletně',
  3: 'Ročně',
}

export const ContributionTypeLabels: Record<ContributionType, string> = {
  1: 'Zaměstnanec',
  2: 'ORBIT',
}

export interface PensionContributionListItem {
  id: number
  employeeId: number
  employeeFullName: string
  departmentName: string | null
  pensionProvider: string
  amount: number
  frequency: ContributionFrequency
  contributionType: ContributionType
  validFrom: string | null
  validTo: string | null
}

export interface PensionContributionDetail {
  id: number
  employeeId: number
  employeeFullName: string
  departmentName: string | null
  pensionProvider: string
  accountNumber: string
  variableSymbol: string
  specificSymbol: string
  amount: number
  frequency: ContributionFrequency
  contributionType: ContributionType
  validFrom: string | null
  validTo: string | null
  note: string | null
}

export interface SavePensionContributionRequest {
  employeeId: number
  pensionProvider: string
  accountNumber: string
  variableSymbol: string
  specificSymbol: string
  amount: number
  frequency: ContributionFrequency
  contributionType: ContributionType
  validFrom: string | null
  validTo: string | null
  note: string | null
}

export const pensionContributionsService = {
  getAll: (params: { search?: string; activeOnly?: boolean; employeeId?: number } = {}) =>
    apiClient.get<PensionContributionListItem[]>('/pension-contributions', { params }).then(r => r.data),

  getById: (id: number) =>
    apiClient.get<PensionContributionDetail>(`/pension-contributions/${id}`).then(r => r.data),

  create: (req: SavePensionContributionRequest) =>
    apiClient.post<{ id: number }>('/pension-contributions', req).then(r => r.data),

  update: (id: number, req: SavePensionContributionRequest) =>
    apiClient.put(`/pension-contributions/${id}`, req),

  delete: (id: number) =>
    apiClient.delete(`/pension-contributions/${id}`),

  downloadExport: async () => {
    const res = await apiClient.get('/exports/pension-contributions', { responseType: 'blob' })
    const url = URL.createObjectURL(res.data)
    const a = document.createElement('a')
    a.href = url
    a.download = `Prispevky_na_stari_${new Date().toISOString().slice(0, 10)}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  },
}
